export const i18DocumentsPrefix = 'documents2';

export const isFolderNameValid = (folderName: any) => {
  folderName = folderName.trim();
  const regex = /[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};:\\|,.<>/?]/;
  return regex.test(folderName);
};
